import { module } from 'stereomodularjs';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import ResizeObserver from 'resize-observer-polyfill';

gsap.registerPlugin(ScrollTrigger);

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.sections = gsap.utils.toArray(this.el.querySelectorAll('[data-testimonials-item]'));
        this.bullets = gsap.utils.toArray(this.el.querySelectorAll('[data-testimonials-bullet]'));

        this.sections.forEach(section => {
            const id = this.sections.indexOf(section) + 1;

            this.scrollTrigger = ScrollTrigger.create({
                trigger: section,
                start: 'top 49%',
                end: 'bottom 49%',
                pin: false,
                pinSpacing: false,
                scrub: 1,
                markers: false, // Mettre à true pour debug
                onEnter: () => {
                    this.el.querySelector(`[data-testimonials-bullet="${id}"]`).classList.add('is-active');
                },
                onLeave: () => {
                    if (id !== this.sections.length) { // Skip removing for the last element
                        this.el.querySelector(`[data-testimonials-bullet="${id}"]`).classList.remove('is-active');
                    }
                },
                onEnterBack: () => {
                    this.el.querySelector(`[data-testimonials-bullet="${id}"]`).classList.add('is-active');
                },
                onLeaveBack: () => {
                    if (id !== 1) { // Skip removing for the first element
                        this.el.querySelector(`[data-testimonials-bullet="${id}"]`).classList.remove('is-active');
                    }
                }
            });

            let resize_timeout;

            const resize_observer = new ResizeObserver(() => {
                clearTimeout(resize_timeout);
                resize_timeout = setTimeout(() => {
                    ScrollTrigger.update();
                }, 11);
            });

            resize_observer.observe(document.querySelector('body'));

            // Fallback for window resize events
            this.handleWindowResize = () => {
                clearTimeout(resize_timeout);
                resize_timeout = setTimeout(() => {
                    ScrollTrigger.update();
                }, 11);
            };
            window.addEventListener('resize', this.handleWindowResize);
        });
    }

    destroy() {
        this.sections.forEach(section => {
            this.scrollTrigger.kill();
        });

        // Disconnect ResizeObserver
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }

        // Remove window resize event listener
        if (this.handleWindowResize) {
            window.removeEventListener('resize', this.handleWindowResize);
            this.handleWindowResize = null;
        }
    }
}
